export const FONT_SIZE_TYPOGRAPHY = {
  fontSize: {
    xs: 8,
    md: 10,
  },
};
